<template>
  <v-card elevation="1">
    <v-dialog v-model="actionsModal" max-width="50%">
      <v-card class="popup-card" elevation="1">
        <v-card-title class="popupHeadline" style="font-size: 24px">
          <div class="text-center popupHeadline" style="width: 100%">
            {{ $t("buttons." + (isEditMode ? "update" : "add")) }}
          </div>
        </v-card-title>
        <v-divider class="mb-4" />

        <ValidationObserver
          ref="actionsOnExhangeRateObserver"
          v-slot="{ handleSubmit }"
        >
          <form @submit.prevent="handleSubmit(submitForm)">
            <v-card-text>
              <v-row>
                <FormElement
                  v-for="(element, index) in formItems"
                  :key="
                    element.key.parent + '_' + element.key.child + '_' + index
                  "
                  v-model="$data[element.key.parent][element.key.child]"
                  :validationLabel="$t(element.validationLabel)"
                  :rules="element.rules"
                  :formLabel="$t(element.formLabel)"
                  :onChange="element.onChange"
                  :formType="element.formType"
                  :lg="element.lg"
                  :cols="element.cols"
                  :disabled="element.disabled"
                  :hidden="element.hidden"
                  :labelShown="element.labelShown"
                  :active="element.active"
                  :topLabel="element.topLabel"
                  :classes="element.classes"
                  :placeholder="$t(element.placeholder)"
                />
                <v-col
                  style="padding-top: 0; padding-bottom: 0"
                  v-if="form.FileUrl"
                >
                  <a target="_blank" :href="form.FileUrl">{{
                    $t("description.fileCount", { value: 1 })
                  }}</a>
                </v-col>
                <FormElement
                  v-for="(element, index) in fileFormItems"
                  :key="
                    element.key.parent + '_' + element.key.child + '_' + index
                  "
                  v-model="$data[element.key.parent][element.key.child]"
                  :validationLabel="$t(element.validationLabel)"
                  :rules="element.rules"
                  :formLabel="$t(element.formLabel)"
                  :onChange="element.onChange"
                  :formType="element.formType"
                  :lg="element.lg"
                  :cols="element.cols"
                  :disabled="element.disabled"
                  :hidden="element.hidden"
                  :labelShown="element.labelShown"
                  :active="element.active"
                  :topLabel="element.topLabel"
                  :classes="element.classes"
                  :placeholder="$t(element.placeholder)"
                  :fileStyling="false"
                />
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                style="
                  color: #fff;
                  text-transform: unset !important;
                  background-color: #0077d5;

                  padding: 1vh 1vh;
                  border-radius: 30px !important;
                  font-weight: bolder;
                  font-size: medium;
                "
                elevation="0"
                class="darken-1"
                type="submit"
                :loading="$store.state.loadingStatus"
                >{{ $t("buttons.save") }}</v-btn
              >
              <v-btn
                style="
                  color: #fff;
                  text-transform: unset !important;
                  background-color: var(--red);
                  padding: 1vh 1vh;
                  border-radius: 30px !important;
                  font-weight: bolder;
                  font-size: medium;
                "
                elevation="0"
                class="darken-1"
                @click="actionsModal = false"
                >{{ $t("buttons.cancel") }}</v-btn
              >
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <v-card-title class="d-flex flex-row" style="color: var(--darkBlue)">
      <v-row>
        <v-col class="text-lg-left text-center" lg="12" cols="12">
          <h3>{{ $t("navigationDrawerMenu.announcementManagement") }}</h3>
        </v-col>
      </v-row>
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-3"
              style="font-size: 32px"
              v-bind="attrs"
              v-on="on"
              @click="actionsModal = true"
            >
              mdi-plus-box-outline
            </v-icon>
          </template>
          <span>{{ $t("buttons.add") }}</span>
        </v-tooltip>
        <RefreshButton :refreshFunction="getItems"></RefreshButton>
      </div>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
        :loading="$store.state.loadingStatus"
        :options="{
          itemsPerPage: itemsPerPage,
        }"
        :item-key="'Id'"
        :no-data-text="$t('messages.noData')"
      >
        <template v-slot:footer>
          <div class="d-flex justify-center mt-8">
            <v-row align="center" justify="center">
              <v-col
                v-if="
                  $vuetify.breakpoint.md ||
                  $vuetify.breakpoint.lg ||
                  $vuetify.breakpoint.xl
                "
                md="2"
              ></v-col>
              <v-col cols="9" sm="12" md="7" lg="7" xl="7">
                <v-pagination
                  v-if="pageLength > 0"
                  class="my-4"
                  @input="onPageChange"
                  v-model="page"
                  :length="pageLength"
                  :total-visible="10"
                  circle
                ></v-pagination>
              </v-col>
              <v-col
                cols="11"
                sm="11"
                md="3"
                lg="3"
                xl="3"
                class="ml-md-auto d-flex align-center mb-6 mb-md-0 pr-3 pr-md-6"
              >
                <v-select
                  v-model="itemsPerPage"
                  :items="perPageValues"
                  :label="$t('labels.selectItemsPerPage')"
                  item-value="value"
                  item-text="name"
                  outlined
                  dense
                  @change="changeItemsPerPage"
                  rounded
                >
                </v-select>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="my-10 d-flex flex-column align-center">
            <h4>{{ $t("messages.noData") }}</h4>
          </div>
        </template>
        <!-- eslint-disable -->
        <template v-slot:item.CreatedOnUtc="{ item }">
          {{ item.CreatedOnUtc ? convertToLocal(item.CreatedOnUtc) : "-" }}
        </template>
        <template v-slot:item.Description="{ item }">
          {{
            `${item.Description.substring(0, 50)} ${
              item.Description.length >= 50 ? "..." : ""
            }`
          }}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-start">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="#29B7B7"
                  class="mr-1"
                  style="font-size: 20px"
                  v-bind="attrs"
                  v-on="on"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>{{ $t("buttons.update") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="red"
                  class="mr-1"
                  style="font-size: 20px"
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteItem(item.Id)"
                >
                  mdi-trash-can
                </v-icon>
              </template>
              <span class="text-uppercase">{{ $t("buttons.remove") }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.FileUrl" top>
              <template v-slot:activator="{ on, attrs }">
                <a :href="item.FileUrl" target="_blank">
                  <v-icon
                    small
                    class="mr-2 green-icon"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-download
                  </v-icon>
                </a>
              </template>
              <span>{{ $t("buttons.download") }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { ITEMS_PER_PAGE_OPTIONS, removeNullValues } from "../utils/constants";
import FormElement from "../components/FormElement.vue";
import formatDate from "../utils/formatDate";
import RefreshButton from "../components/RefreshButton.vue";
import TabScreen from "../components/TabScreen.vue";
import AnnouncementService from "../services/AnnouncementService";
import uploadFile from "../utils/uploadFile";
import CheckTable from "../components/CheckTable.vue";

export default {
  data() {
    return {
      companies: [],
      countries: [],
      marketplaces: [],
      headers: [],
      items: [],
      statuses: [],

      // Filters
      currencyCode: "",
      validityDate: new Date(),

      // States
      itemsPerPage: 10,
      page: 1,
      totalItems: 0,
      perPageValues: [
        {
          name: "5",
          value: 5,
        },
        {
          name: "10",
          value: 10,
        },
        {
          name: "15",
          value: 15,
        },
        {
          name: "30",
          value: 30,
        },
        {
          name: "50",
          value: 50,
        },
        {
          name: "100",
          value: 100,
        },
        {
          name: this.$t("labels.All"),
          value: 9999,
        },
      ],
      isEditMode: false,

      actionsModal: false,
      form: {
        ValidityDate: "",
      },

      slots: [],
      centralBankExchangeRateList: [],
      selectedTab: 0,
      dateFilter: new Date(),

      file: {
        loading: "",
        data: null,
        url: "",
      },
    };
  },
  components: { FormElement, RefreshButton, TabScreen, CheckTable },
  mounted() {
    this.itemsPerPageOptions = ITEMS_PER_PAGE_OPTIONS;
    this.setup();
  },
  watch: {
    actionsModal(newValue) {
      if (!newValue) {
        this.$refs.actionsOnExhangeRateObserver.reset();
        this.form = {
          ValidityDate: "",
          CustomerCompanyIds: [],
        };
        this.isEditMode = false;
      }
    },
  },
  computed: {
    formItems() {
      return [
        {
          key: {
            parent: "form",
            child: "Title",
          },
          rules: "required",
          validationLabel: "labels.titleHr",
          formType: {
            name: "text",
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          placeholder: "labels.titleHr",
        },
        {
          key: {
            parent: "form",
            child: "Description",
          },
          rules: "required",
          validationLabel: "labels.description",
          formType: {
            name: "textarea",
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          placeholder: "labels.description",
        },
      ];
    },

    fileFormItems() {
      return [
        {
          key: {
            parent: "file",
            child: "data",
          },
          validationLabel: "labels.file",
          formType: {
            name: "file",
            showSize: true,
            data: {
              accept: [
                ".docx",
                ".doc",
                ".bmp",
                ".png",
                ".jpeg",
                ".xls",
                ".xlsx",
                ".pdf",
              ].join(","),
            },
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          formLabel: false,
          cols: 12,
          classes: this.form.FileUrl ? "mt-4" : "",
          placeholder: "labels.file",
        },
        {
          key: {
            parent: "form",
            child: "CustomerCompanyIds",
          },
          validationLabel: "labels.customer",
          formType: {
            name: "checkTable",
            visible: this.actionsModal,
            unselectedItems: this.companies,
            selectedItems: this.form.CustomerCompanyIds || [],
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          placeholder: "labels.customer",
        },
      ];
    },

    pageLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },
  methods: {
    editItem(item) {
      this.actionsModal = true;
      this.isEditMode = true;

      this.form = Object.assign({}, item);
    },
    deleteItem(Id) {
      this.$store.state.loadingStatus = true;
      AnnouncementService.delete({
        Id,
      })
        .then((response) => {
          window.showSuccess(this.$t("messages.successfulDelete"));
          this.getItems();
        })
        .catch(window.showError)
        .finally(() => (this.$store.state.loadingStatus = false));
    },

    changeItemsPerPage() {
      this.page = 1;
      this.getItems();
    },

    /**
     * Trigger when page changed.
     */
    onPageChange() {
      this.getItems();
    },

    async getCompanies() {
      this.$store.state.loadingStatus = true;
      AnnouncementService.getCompaniesForAnnouncements()
        .then((response) => {
          const data = response.data;
          if (data) {
            this.companies = response.data.Result;
          }
        })
        .catch(window.showError)
        .finally(() => (this.$store.state.loadingStatus = false));
    },

    async setup() {
      this.companies = await this.getCompanies();

      this.getItems();
      this.headers = [
        {
          text: this.$t("labels.titleHr"),
          value: "Title",
          sortable: false,
          groupable: false,
          cellClass: "regular-cell",
          align: "center",
        },
        {
          text: this.$t("labels.description"),
          value: "Description",
          sortable: false,
          groupable: false,
          cellClass: "regular-cell",
        },
        {
          text: this.$t("titles.announcementDate"),
          value: "CreatedOnUtc",
          sortable: false,
          groupable: false,
          cellClass: ["regular-cell"],
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderActions"),
          value: "actions",
          sortable: false,
        },
      ];
    },

    /**
     * Get search history from service.
     */
    getItems() {
      this.$store.state.loadingStatus = true;
      AnnouncementService.getAnnouncementsForSupplier({
        Page: this.page,
        PageSize: this.itemsPerPage,
      })
        .then((response) => {
          this.items = response.data.Result;
          this.totalItems = response.data.TotalItems;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    async submitForm(isUploaded = false) {
      this.$store.state.loadingStatus = true;

      if (!isUploaded && this.file.data) {
        await uploadFile(this.file.data, (url) => {
          this.file.url = url;
          this.submitForm(true);
        });
        return;
      }

      let body = this.form,
        requestFunction = null;

      if (this.file.url) {
        body.FileUrl = this.file.url;
      }

      try {
        requestFunction = this.isEditMode
          ? AnnouncementService.update
          : AnnouncementService.add;

        if (requestFunction) {
          requestFunction(body)
            .then((response) => {
              window.showSuccess(
                this.$t(
                  `messages.${
                    this.isEditMode
                      ? "successfulUpdateGeneral"
                      : "successfulAddGeneral"
                  }`
                )
              );
              this.actionsModal = false;
              this.getItems();

              this.file = {
                data: null,
                url: "",
              };
            })
            .catch(window.showError)
            .finally(() => {
              this.$store.state.loadingStatus = false;
            });
        }
      } catch (error) {
        window.showError(error);
      }
    },
  },
};
</script>
<style></style>
